// src/pages/Users/Inscription/components/SelectedGroupCard.jsx

import React from "react";
import { FaInfoCircle, FaMapMarkerAlt, FaTimes } from "react-icons/fa";

import {
  formatEuro,
  getColorMeta,
  getGroupQuota,
  getGroupSchedules,
} from "../utils/inscriptionUtils";

export default function SelectedGroupCard({ group, dojo, onRemove }) {
  const color = getColorMeta(group.color_groupe);
  const quota = getGroupQuota(group);
  const schedules = getGroupSchedules(group);
  const total =
    Number(group.tarif_licence || 0) + Number(group.tarif_cotisation || 0);

  const hasInfoGroupe = Boolean(String(group.info_groupe || "").trim());

  return (
    <article
      className={`relative overflow-hidden rounded-[2rem] border ${color.border} bg-white shadow-sm dark:bg-slate-900`}
    >
      <div className={`absolute inset-y-0 left-0 w-2 ${color.solid}`} />

      <button
        type="button"
        onClick={onRemove}
        className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-2xl border border-rose-200 bg-rose-50 text-rose-700 transition hover:bg-rose-100 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
        title="Retirer ce groupe"
      >
        <FaTimes />
      </button>

      <div className="p-5 pl-7 pr-14">
        <h3 className="text-lg font-bold text-slate-950 dark:text-white">
          {group.nom}
        </h3>

        <p className="mt-2 inline-flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
          <FaMapMarkerAlt />
          {dojo?.dojo_nom || "Lieu non renseigné"}
        </p>

        {schedules.length ? (
          <div className="mt-4 flex flex-wrap gap-2">
            {schedules.slice(0, 3).map((schedule) => (
              <span
                key={schedule}
                className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-700 dark:bg-slate-800 dark:text-slate-200"
              >
                {schedule}
              </span>
            ))}
          </div>
        ) : null}

        <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
          <div className="rounded-2xl bg-slate-50 p-3 dark:bg-slate-950/70">
            <p className="text-slate-500 dark:text-slate-400">Quota</p>
            <p className="mt-1 font-bold text-slate-900 dark:text-white">
              {quota.hasQuota
                ? `${quota.members}/${quota.quota}`
                : "Sans quota"}
            </p>
          </div>

          <div className="rounded-2xl bg-emerald-50 p-3 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300">
            <p>Total</p>
            <p className="mt-1 font-bold">{formatEuro(total)}</p>
          </div>
        </div>

        {/* Description / informations complémentaires du groupe */}
        {hasInfoGroupe ? (
          <div className="mt-4 rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-950/60">
            <div className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              <FaInfoCircle className="text-slate-400" />
              Informations complémentaires
            </div>

            <div
              className="
                prose prose-sm max-w-none
                text-sm leading-relaxed text-slate-700
                prose-p:my-2
                prose-ul:my-2 prose-ul:pl-5
                prose-ol:my-2 prose-ol:pl-5
                prose-li:my-1
                prose-strong:text-slate-900
                dark:prose-invert
                dark:text-slate-200
                dark:prose-strong:text-white
              "
              dangerouslySetInnerHTML={{
                __html: group.info_groupe,
              }}
            />
          </div>
        ) : null}
      </div>
    </article>
  );
}